import React from "react";
import {
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import RadioButton from "./radio";

const RadioGroupCustom = ({ value, setValue, options = [] }) => {
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <FormControl>
      <RadioGroup
        row
        value={value}
        onChange={handleChange}
      >
        {
          options.map(op => (
            <FormControlLabel 
              className={`${value === op ? 'bg-primary text-white' : 'bg-white text-dark'} ps-3 my-1 btn-bordered-sm chip-radio`} 
              key={`radio-${op}`} 
              value={op} 
              control={<RadioButton checkedcolor="#fff"/>} 
              label={op ?? ''} 
            />
          ))
        }
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupCustom;
